import styled from 'styled-components';
import { media, layout } from 'src/components/base';
import { OutlinedButton } from '@prisjakt/ui/button/variants';

export const FeaturedArticle = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;

  /* Add extra spacing to panel header which has 12px - Should be 24 in desktop and 16 on mobile */
  padding-top: 12px;
  ${media.smallOnly`
    padding-top: 4px;
  `};

  ${media.mediumUp`
    flex-direction: row;
  `};

  ${media.showOutsiderAd`
    padding-right: ${layout.measurements.spacing025};
  `}
`;

export const ArticleLink = styled(OutlinedButton)`
  ${media.smallOnly`
    width: 100%;

    > span {
      flex-grow: 0;
    }
  `};
`;

export const TextContainer = styled.div`
  ${media.mediumUp`
    flex-basis: 60%;
  `};
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  min-height: 170px;

  ${media.smallOnly`
    margin-bottom: ${layout.measurements.spacing100};
  `};

  ${media.mediumUp`
    flex-basis: 40%;
    max-width: 300px;
    padding-right: ${layout.measurements.spacing150};
  `}
`;
